import FlowEnum from '../../../types/FlowEnum';
import { useGlobalState } from '../../../state/persistence';
import { useEffect } from 'react';
const UrlFlowMap = {
  [FlowEnum.CHECK_PRIVATE]: `${process.env.REACT_APP_ORDER_URL}/wohnen/haushalt-fw10`,
  [FlowEnum.CHECK_BUSINESS]: `${process.env.REACT_APP_ORDER_URL}/gewerbe`,
};

const useDirectAccessAllowed = (componentFlow: FlowEnum | null = null, isAllowed = false) => {
  const { appStore, dispatchAppStore } = useGlobalState();

  useEffect(() => {
    if (isAllowed && componentFlow && !appStore.flow) {
      dispatchAppStore('flow', componentFlow);
    }

    const getStarterUrl = () => UrlFlowMap[componentFlow!];

    const denyDirectAccess = () => {
      const url = getStarterUrl();

      window.location.assign(url);
    };

    const hasEqualFlow = () => componentFlow && componentFlow === appStore.flow;

    if (!isAllowed && !hasEqualFlow()) {
      denyDirectAccess();
    }
  });
};

export default useDirectAccessAllowed;
